const ELMORA_CDN = 'https://neoterra-site.b-cdn.net/project/elmora';

export const visualOneBedBedroom = `${ELMORA_CDN}/1bed%20bedroom.jpeg`;
export const visualTwoBedBedroom = `${ELMORA_CDN}/2bed%20bedroom.jpeg`;
export const visualBuildingFacade = `${ELMORA_CDN}/Building%20facade.jpg`;
export const visualBusinessLounge = `${ELMORA_CDN}/Business%20Lounge.jpg`;
export const meetsIllustration = `${ELMORA_CDN}/detailed-illustration.jpeg`;
export const elmoraBrochurePdf = `${ELMORA_CDN}/Elmora%20Brochure.pdf`;
export const visualInfinityPool = `${ELMORA_CDN}/Infinity%20Pool.jpg`;
